import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,{attrs:{"dense":""}},_vm._l((_vm.items),function(item){return _c(VCol,{key:item.name,attrs:{"cols":"6","dense":""}},[_c('div',{staticClass:"text-body-2"},[_vm._v(_vm._s(item.name))]),_c('div',[_c(VSwitch,{attrs:{"dense":"","value":item.name},on:{"change":function($event){return _vm.updateValue($event)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }